import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { TYPE_LABEL } from "@/types/movie";

interface MovieCardProps {
  movie: Movie;
  className?: string;
}

export default function MovieCard({ movie, className = "" }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className={`group block bg-background-50 border border-background-200 rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 ${className}`}
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 缘之空影视详情及剧情介绍`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-foreground-950/75 text-accent-300 text-xs font-bold">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2 left-2 px-2 py-0.5 rounded-md bg-primary-500/90 text-background-50 text-xs">
          {TYPE_LABEL[movie.type]}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading font-bold text-foreground-950 text-sm md:text-base truncate group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs md:text-sm text-foreground-500 truncate">
          {movie.genres.join(" · ")}
        </p>
        <div className="mt-2 flex items-center gap-2 text-xs text-foreground-400">
          <span>{movie.region}</span>
          <span className="w-px h-3 bg-background-300"></span>
          <span>{movie.year}</span>
        </div>
      </div>
    </Link>
  );
}